import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "eGeeTouch® luggage lock is built with a TSA-Approved mechanical key lock. TSA authorized personnel is able to use assigned TSA master key to unlock/lock your eGeeTouch® smart lock in the event they need to inspect its contents. For more info on Tests & Certifications, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "eGeeTouch® ラゲッジ ロックは、TSA 承認のメカニカル キー ロックを使用して構築されています。 TSA 認定職員は、中身を検査する必要がある場合に、割り当てられた TSA マスター キーを使用して eGeeTouch® スマート ロックの解錠/施錠を行うことができます。テストと認定の詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "El candado para equipaje eGeeTouch® está construido con un candado de llave mecánico aprobado por la TSA. El personal autorizado de la TSA puede utilizar la llave maestra de la TSA asignada para desbloquear/bloquear su candado inteligente eGeeTouch® en caso de que necesite inspeccionar su contenido. Para obtener más información sobre pruebas y certificaciones, ",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q9_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q9_component;
